export default __webpack_public_path__ + "static/media/header.88df76f3.png";